var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mt-2" }, [
    _c(
      "div",
      { staticClass: "col-6" },
      [
        _c("vs-input", {
          staticClass: "w-100",
          attrs: { readonly: "", label: "Entidad" },
          model: {
            value: _vm.entity,
            callback: function($$v) {
              _vm.entity = $$v
            },
            expression: "entity"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-6" },
      [
        _c("vs-input", {
          staticClass: "w-100",
          attrs: { readonly: "", label: "Materia" },
          model: {
            value: _vm.theme,
            callback: function($$v) {
              _vm.theme = $$v
            },
            expression: "theme"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-12 mt-2" },
      [
        _c("label", [_vm._v("Descripción")]),
        _c("b-form-textarea", {
          staticClass: "w-100",
          attrs: { rows: "1", readonly: "", "no-resize": "" },
          model: {
            value: _vm.description,
            callback: function($$v) {
              _vm.description = $$v
            },
            expression: "description"
          }
        })
      ],
      1
    ),
    _c("div", { staticClass: "col-6 mt-2" }, [
      _c("label", [_vm._v("Firmado por:")]),
      _c(
        "div",
        [
          !_vm.signers.length
            ? _c("p", [_vm._v(" No tiene firmantes ")])
            : _vm._e(),
          _vm._l(_vm.signers, function(user, index) {
            return _c(
              "b-media",
              { key: index, staticClass: "mb-2", attrs: { "no-body": "" } },
              [
                _c(
                  "b-media-aside",
                  { staticClass: "mr-75" },
                  [_c("b-avatar", { attrs: { rounded: "", size: "36" } })],
                  1
                ),
                _c("b-media-body", { staticClass: "my-auto" }, [
                  _c("h6", { staticClass: "mb-0" }, [
                    _vm._v(" " + _vm._s(user.name) + " ")
                  ]),
                  _c("small", [_vm._v(_vm._s(user.entityName))])
                ])
              ],
              1
            )
          })
        ],
        2
      )
    ]),
    _c("div", { staticClass: "col-6 mt-2" }, [
      _c(
        "div",
        [
          _c("label", [_vm._v("Visadores:")]),
          !_vm.certifiers.length
            ? _c("p", [_vm._v(" No tiene visadores ")])
            : _vm._e(),
          _vm._l(_vm.certifiers, function(user, index) {
            return _c(
              "b-media",
              { key: index, staticClass: "mb-2", attrs: { "no-body": "" } },
              [
                _c(
                  "b-media-aside",
                  { staticClass: "mr-75" },
                  [_c("b-avatar", { attrs: { rounded: "", size: "36" } })],
                  1
                ),
                _c("b-media-body", { staticClass: "my-auto" }, [
                  _c("h6", { staticClass: "mb-0" }, [
                    _vm._v(" " + _vm._s(user.name) + " ")
                  ]),
                  _c("small", [_vm._v(_vm._s(user.entityName))])
                ])
              ],
              1
            )
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }